export default "__VITE_ASSET__401e6b33__"